module.exports = __webpack_public_path__ + "media/homemp43.8f75cc85.mp4";